import React from "react";
import cx from "classnames";

import LoadingSection from "../LoadingSection";
import { useLocalization } from "../../../context/LocalizeContextProvider";
import Pagination from "../Pagination";

export default function Table({
  columns,
  children,
  loading,
  activePage,
  totalPage = 0,
  totalShow = 0,
  totalEntries = 0,
  handlePagination,
  noPagination = false,
  isHovered = false,
  handleSizePerPage = () => undefined,
  sizePerPage = 50,
  sortState = null,
  setSortState = () => undefined,
}) {
  const localize = useLocalization();

  return (
    <div className="table-responsive">
      <div className="h-100 pb-3">
        <table
          className={cx(
            isHovered && "table table-hover",
            "display w-100 dataTable"
          )}
        >
          <thead>
            <tr role="row">
              {columns.map((item, index) => (
                <th className={item?.className} style={item.style} key={index}>
                  <div className="d-flex align-items-center gap-2">
                    {item.label}
                    {item?.isSort && (
                      <>
                        {!sortState?.value ? (
                          <i
                            className="fas fa-sort c-pointer"
                            onClick={() =>
                              setSortState({ key: item?.key, value: "asc" })
                            }
                          ></i>
                        ) : sortState?.value === "asc" &&
                          sortState.key === item.key ? (
                          <i
                            className="fas fa-sort-up c-pointer"
                            onClick={() =>
                              setSortState({ key: item?.key, value: "desc" })
                            }
                          ></i>
                        ) : sortState.key === item.key ? (
                          <i
                            className="fas fa-sort-down c-pointer"
                            onClick={() => setSortState({ key: "", value: "" })}
                          ></i>
                        ) : (
                          <i
                            className="fas fa-sort c-pointer"
                            onClick={() =>
                              setSortState({ key: item?.key, value: "asc" })
                            }
                          ></i>
                        )}
                      </>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  <LoadingSection />
                </td>
              </tr>
            ) : totalEntries <= 0 ? (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  {localize.getText("noData")}
                </td>
              </tr>
            ) : (
              children
            )}
          </tbody>
        </table>

        {!noPagination && totalEntries > 0 && (
          <Pagination
            activePage={activePage}
            totalPage={totalPage}
            totalShow={totalShow}
            totalEntries={totalEntries}
            handlePagination={handlePagination}
            handleSizePerPage={handleSizePerPage}
            sizePerPage={sizePerPage}
          />
        )}
      </div>
    </div>
  );
}
